import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { MeetingComponent } from './meeting/meeting.component';
import { FeedbacksComponent } from './feedbacks/feedbacks.component';
import { JoinCallComponent } from './join-call/join-call.component';
import { ParamExistsGuard } from './services/checkurl.gaurd';
import { EmotionalanalysisComponent } from './emotionalanalysis/emotionalanalysis.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { permissionGuard } from './services/permission.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [permissionGuard] },
  {
    path: 'room/:id',
    component: MeetingComponent,
    canActivate: [ParamExistsGuard],
  },
  {
    path: 'feedback/:id',
    component: FeedbacksComponent,
    canActivate: [permissionGuard],
  },
  {
    path: 'joincall/:id',
    component: JoinCallComponent,
    canActivate: [permissionGuard],
  },
  {
    path: 'emotions/:id',
    component: EmotionalanalysisComponent,
    canActivate: [permissionGuard],
  },
  { path: 'errorpage/:id', component: ErrorpageComponent },
  // { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
